import React, { Dispatch, SetStateAction, useState } from 'react';
import { Components } from './styled';
import ProjectTextField from '../../../../inputs/ProjectTextField';
import useFormTextState from '../../../../../hooks/useFormTextState';
import { ReactComponent as CheckIcon } from '../../../../../assets/icons/icon-check-alt.svg';

const AddKeyTakeaways = ({ data, setData }: { data: string[]; setData: Dispatch<SetStateAction<string[]>> }) => {
  const [selectedEntry, setSelectedEntry] = useState<{ index: number; text: string } | undefined>();
  const [isEditing, setIsEditing] = useState(false);

  const textFieldProps = useFormTextState();

  const onAddEntry = () => {
    setData((oldProps) => (textFieldProps.value ? oldProps.concat([textFieldProps.value]) : oldProps));
    textFieldProps.setValue('');
  };

  const onUpdateEntry = () => {
    if (selectedEntry && textFieldProps.value && textFieldProps.value?.length) {
      const newArray = [...data];
      newArray[selectedEntry?.index] = textFieldProps.value;
      setData(newArray);
      setSelectedEntry(undefined);
    }
    textFieldProps.setValue('');
    setIsEditing(false);
  };

  const onSelectEntry = (index: number, text: string) => {
    setSelectedEntry({ index, text });
  };

  const onEditEntry = () => {
    if (selectedEntry) {
      setIsEditing(true);
      textFieldProps.setValue(selectedEntry?.text);
    }
  };

  const onDeleteEntry = () => {
    if (selectedEntry) {
      const newArray = [...data];
      newArray?.splice(selectedEntry?.index, 1);
      setData(newArray);
    }
  };

  return (
    <Components.Container>
      <Components.ListAndButtonsWrapper>
        <Components.ListContainer>
          {data?.map((item, key) => (
            <Components.ListEntry key={key} onClick={() => onSelectEntry(key, item)}>
              <Components.ListEntryText>{item}</Components.ListEntryText>
              {key === selectedEntry?.index && (
                <Components.CheckIconWrapper>
                  <CheckIcon />
                </Components.CheckIconWrapper>
              )}
            </Components.ListEntry>
          ))}
        </Components.ListContainer>
        <Components.ButtonsContainer>
          <Components.EditButton onClick={onEditEntry}>Edit</Components.EditButton>
          <Components.DeleteButton onClick={onDeleteEntry}>Delete</Components.DeleteButton>
        </Components.ButtonsContainer>
      </Components.ListAndButtonsWrapper>
      <Components.FooterContainer>
        <ProjectTextField {...textFieldProps} placeholder={'Enter key takeaway text'} />
        <Components.AddButton onClick={isEditing ? onUpdateEntry : onAddEntry}>
          {isEditing ? 'Update' : 'Add'}
        </Components.AddButton>
      </Components.FooterContainer>
    </Components.Container>
  );
};

export default AddKeyTakeaways;
